import React, { ReactNode } from 'react';

const SearchResultRow = (props: { children: ReactNode }): React.JSX.Element => {
  return <div data-search-result-row="true">{props.children}</div>;
};

export default SearchResultRow;
